import Icon from 'atoms/Icon';
import Text from 'atoms/Text';
import { useEffect } from 'react';

function Toast({
    show = false,
    message = 'Created successfully',
    description = '',
    variant = 'success',
    onClose,
    children,
    closeLabel = 'Close',
    icon = 'alert__l__stroke',
    isIcon = false
}) {
    if (!show) return null;

    const style = {
        success: 'bg-green-900',
        error: 'bg-red-900',
        info: 'bg-blue-900',
        infoBlack: 'bg-black'
    };

    useEffect(() => {
        if(variant === 'success') {
            setTimeout(() => onClose(), 2000)
        }
    }, []);

    return (
        <div className='bg-black bg-opacity-30 fixed top-0 left-0 w-full h-full z-[1100]'>
            <div className={`${style[variant]} max-w-[95%] md:max-w-[840px] mx-auto mt-20 text-white w-fit relative`}>
                <div className='flex justify-between items-center'>
                    <div className='flex items-center gap-1 px-5 py-2'>
                        {isIcon && <Icon icon={icon} color='white'/>}
                        <Text variant='body'>{message}</Text>
                    </div>
                    {variant !== 'success' && <Text onClick={onClose} className='cursor-pointer transition-all px-5 py-3 hover:bg-black hover:bg-opacity-10'>{closeLabel}</Text>}
                </div>
                {description && <Text variant='label' className='pb-3 px-5'>{description}</Text>}
                {children}
            </div>
        </div>
    );
}

export default Toast;
